import fieldsOfStudy from '@/data/fieldsofstudy'

export interface Field {
  name: string
  studyName: string
  educationalArea: string
}

export interface StudyData {
  Studiekode: string
  Studienavn: string
  Lærested: string
  Studiested: string
  Utdanningsområde: string
  ORD: number
  ORDF?: number | string
}

export const fields: Field[] = [
  { name: 'Se alle studier', studyName: '', educationalArea: '' },
  {
    name: 'Fysioterapi',
    studyName: 'Fysioterapi',
    educationalArea: 'HELSEFAG - FYSIO',
  },
  {
    name: 'Grunnskolelærer 1-7',
    studyName: 'Grunnskolelærer',
    educationalArea: 'LÆRER - GLU1-7',
  },
  {
    name: 'Grunnskolelærer 5-10',
    studyName: 'Grunnskolelærer',
    educationalArea: 'LÆRER - GLU5-10',
  },
  {
    name: 'Idrett',
    studyName: 'Idrett',
    educationalArea: 'IDRETT',
  },
  {
    name: 'IT/Informatikk',
    studyName: 'Informatikk',
    educationalArea: 'INFOTEKN',
  },
  {
    name: 'Medisin',
    studyName: 'Medisin',
    educationalArea: 'HELSEFAG - MEDISIN',
  },
  {
    name: 'Odontologi',
    studyName: 'Odontologi',
    educationalArea: 'HELSEFAG - ODONT',
  },
  {
    name: 'Psykologi',
    studyName: 'Psykologi',
    educationalArea: 'SAMFUNN',
  },
  {
    name: 'Rettsvitenskap/Jus',
    studyName: 'Rettsvitenskap',
    educationalArea: 'JUS',
  },
  {
    name: 'Siviløkonom',
    studyName: 'Siviløkonom',
    educationalArea: 'ØKADM',
  },
  {
    name: 'Sykepleie',
    studyName: 'Sykepleie',
    educationalArea: 'HELSEFAG - SYKEPL',
  },
  {
    name: 'Veterinær',
    studyName: 'Veterinær',
    educationalArea: 'HELSEFAG - VETERIN',
  },
]

const allStudiesField = fields[0]

export function getMatchingStudiesForField(field: Field | null): StudyData[] {
  if (!field) {
    return []
  }

  if (field.name === allStudiesField.name) {
    return [...fieldsOfStudy].sort((a, b) =>
      a.Studienavn.localeCompare(b.Studienavn)
    )
  }

  return fieldsOfStudy
    .filter((study) => matchesField(study, field))
    .sort((a, b) => a.Studienavn.localeCompare(b.Studienavn))
}

export function findStudy(savedDreamStudy: string): StudyData | undefined {
  return fieldsOfStudy.find((study) => study.Studiekode === savedDreamStudy)
}

export function matchesField(study: StudyData, field: Field): boolean {
  if (field.name === allStudiesField.name) {
    return true
  }

  const areaMatch = study.Utdanningsområde.toLowerCase().includes(
    field.educationalArea.toLowerCase()
  )
  const nameMatch =
    field.studyName === '' ||
    study.Studienavn.toLowerCase().includes(field.studyName.toLowerCase())

  return areaMatch && nameMatch
}

export function findFieldForStudy(study: StudyData): Field {
  return (
    fields.find(
      (field) =>
        field.name !== allStudiesField.name && matchesField(study, field)
    ) ?? allStudiesField
  )
}
